import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import "./styles/globals.module.scss";
import { ThemeProvider } from "@gataca/design-system/web";
import { applyPolyfills, defineCustomElements } from "@gataca/qr/loader";
import store from "./store/store";
import { Provider } from "react-redux";
import { contentSP } from "./assets/csp";
import { Helmet } from "react-helmet";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

applyPolyfills().then(() => {
  defineCustomElements(window);
});

root.render(
  <div id="main">
    <Helmet>
      <meta http-equiv="Content-Security-Policy" content={contentSP} />
    </Helmet>
    <React.StrictMode>
      <Provider
        store={store()}
        children={
          <ThemeProvider label={"PRIMARY"} children={<App />} />
        }></Provider>
    </React.StrictMode>
  </div>
);
